import { StandaloneConfigProvider } from './standalone-config.js';
import { WidgetConfigProvider } from './widget-config.js';

export const ConfigProvider = __STANDALONE_MODE__
  ? StandaloneConfigProvider
  : WidgetConfigProvider;
